import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { JoinComponent } from './components/join/join.component';
import { LoginComponent } from './components/login/login.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';
import { NgxPaginationModule } from 'ngx-pagination';
import localeKo from '@angular/common/locales/ko';
import { DatePipe, registerLocaleData } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { ClipboardModule } from 'ngx-clipboard';
import { FindIdComponent } from './components/find-id/find-id.component';
import { FindPwComponent } from './components/find-pw/find-pw.component';
import { ImageViewerComponent } from './components/image-viewer/image-viewer.component';
import { MatDialogModule } from '@angular/material/dialog';
import { GuideComponent } from './components/guide/guide.component';
import { TermsComponent } from './components/terms/terms.component';
import { MobileLoginComponent } from './components/mobile/mobile-login/mobile-login.component';
import { MobileOpenEventComponent } from './components/event/mobile-open-event/mobile-open-event.component';
import { OpenEventComponent } from './components/event/open-event/open-event.component';
import { MobileJoinComponent } from './components/mobile/mobile-join/mobile-join.component';
import { MobileGuideComponent } from './components/mobile/mobile-guide/mobile-guide.component';
import { MobileFindIdComponent } from './components/mobile/mobile-find-id/mobile-find-id.component';
import { MobileFindPwComponent } from './components/mobile/mobile-find-pw/mobile-find-pw.component';
import { MobileMypageComponent } from './components/mobile/mobile-mypage/mobile-mypage.component';
import { PipesModule } from './pipes/pipes.module';
import { MobileHistoryComponent } from './components/mobile/mobile-history/mobile-history.component';
import { MobileLinkComponent } from './components/mobile/mobile-link/mobile-link.component';
import { Event20250415Component } from './components/event/event20250415/event20250415.component';
import { MobileEvent20250415Component } from './components/event/mobile-event20250415/mobile-event20250415.component';

registerLocaleData(localeKo);
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    LoginComponent,
    JoinComponent,
    GuideComponent,
    MobileLoginComponent,
    MobileJoinComponent,
    MobileGuideComponent,
    TermsComponent,
    FindIdComponent,
    FindPwComponent,
    MobileFindIdComponent,
    MobileFindPwComponent,
    ImageViewerComponent,
    MobileMypageComponent,
    MobileHistoryComponent,
    MobileLinkComponent,
    //이벤트(오픈이벤트)
    OpenEventComponent,
    MobileOpenEventComponent,
    Event20250415Component,
    MobileEvent20250415Component,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    ToastrModule.forRoot(),
    ClipboardModule,
    MatDialogModule,
    PipesModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
